/**
 * Fichier d'exports allégé - Version lightweight
 * Pages actives : Landing, Authentification, Dashboard, Tracking, TrafficPage, FleetviewSchoolTransport
 * Toutes les autres pages sont commentées pour alléger la compilation
 */

import { useIntl } from "react-intl";

export { default as App } from "./app/App";
export { default as ErrorPage } from "./error/Error";
export { default as UnknowErrorPage } from "./error/UnknowError";

// ============================================
// PAGES ACTIVES - Landing pages
// ============================================
export { default as Home } from "./home/Home";
export { default as About } from "./about/About";
export { default as Feature } from "./feature/Feature";
export { default as Client } from "./client/Client";
export { default as FollowUs } from "./followus/FollowUs";
export { default as ContactUs } from "./contactus/ContactUs";
export { default as Product } from "./product/Product";

// ============================================
// PAGES DÉSACTIVÉES - Pages secondaires
// ============================================
// export { default as Subcription } from "./subscription/Subcription";
// export { default as ActivityDetails } from "./followus/ActivityDetails";
// export { default as MyAccount } from "./myAccount/MyAccount";

// ============================================
// PAGES ACTIVES - Authentification
// ============================================
export { default as SignIn } from "./signin/SignIn";
export { default as SignUp } from "./signup/SignUp";

// ============================================
// PAGES ACTIVES - Dashboard & Tracking
// ============================================
export { default as DashboardPage } from "./dashboard/DashboardPage";

// ============================================
// PAGES DÉSACTIVÉES - MyData (sauf tracking)
// ============================================
// export { default as FleetView } from "./myData/FleetView";

// ============================================
// PAGES ACTIVES - Nouveaux modules
// ============================================
export { default as FleetviewSchoolTransport } from "./fleetviewSchoolTransport";

// ============================================
// PAGES DÉSACTIVÉES - Autres modules
// ============================================
// export { default as NotificationsPage } from "./NotificationsPage/NotificationsPage";
// export { default as SettingsPage } from "./SettingsPage/SettingsPage";

// ============================================
// UTILITAIRES
// ============================================
export function useTranslation() {
  const intl = useIntl();

  const t = (id, values = {}) => intl.formatMessage({ id }, values);

  return { t };
}
